export class MockCollaboratorsService {
  getCollaborators = jasmine.createSpy('getCollaborators');
}
